import { render, staticRenderFns } from "./SintomasOtros.vue?vue&type=template&id=afe9df02"
import script from "./SintomasOtros.vue?vue&type=script&lang=js"
export * from "./SintomasOtros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports